import { useEffect, useState } from "react";
import { CgMenu } from "react-icons/cg";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import { collection, doc, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { firestore } from "../firebase-config";
import { id_firebase_estoque } from "../content-site";

export default function FiltrosAvancados({ filtros, setFiltros }) {
    const [menuAberto, setMenuAberto] = useState(false);
    const [veiculos, setVeiculos] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);

        const q = query(
            collection(doc(collection(firestore, "revenda"), id_firebase_estoque), "veiculos"),
            where("veremovido", "==", 0),
            where("vevendido", "==", 0),
            orderBy("updated_at", "desc")
        );

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
                const document = doc.data();
                document.id = doc.id;
                if (document["veexibir_site"] !== false) {
                    items.push(document);
                }
            });
            setVeiculos(items);
        });

        return () => unsubscribe();
    }, []);

    const getOpcoesFiltro = (campo) => {
        const opcoes = veiculos.map(v => v[campo]).filter(Boolean);
        return [...new Set(opcoes)];
    };

    const precos = veiculos.map(v => v.vevalor).filter(Boolean);
    const precoMinEstoque = precos.length ? Math.min(...precos) : 0;
    const precoMaxEstoque = precos.length ? Math.max(...precos) : 0;

    const toggleMenu = () => {
        setMenuAberto(!menuAberto);
    };

    const filtrosAtivos = Object.values(filtros).filter(v => v && v !== "").length;

    const handleLimparFiltros = () => {
        setFiltros({
            tipo: "",
            cor: "",
            portas: "",
            kmMax: "",
            precoMin: "",
            precoMax: ""
        });
    };

    return (
        <div className="flex flex-col items-center w-full">
            <div className="flex gap-4 items-center justify-center">
                <button
                    onClick={toggleMenu}
                    className={`cursor-pointer flex items-center justify-center gap-2 px-4 py-1 rounded-md shadow-2xl border border-neutral-300 transition-colors duration-200
                    ${menuAberto ? "bg-[#003c85] text-white" : "bg-neutral-200 text-neutral-600 hover:bg-neutral-300"}`}
                >
                    <CgMenu />
                    Filtros Avançados
                    {menuAberto ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
                </button>

                {filtrosAtivos > 0 && (
                    <button
                        onClick={handleLimparFiltros}
                        className="bg-yellow-100 text-yellow-700 px-4 py-1 rounded-md border border-yellow-200 hover:bg-yellow-200 transition-colors"
                    >
                        Limpar filtros ({filtrosAtivos})
                    </button>
                )}
            </div>

            {menuAberto && (
                <div className="w-full flex justify-center">
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 p-6 bg-neutral-50 rounded-lg shadow-sm w-full max-w-6xl">

                        <div className="flex flex-col">
                            <label className="text-sm text-neutral-700 mb-1">Tipo de Veículo</label>
                            <select
                                value={filtros.tipo}
                                onChange={e => setFiltros(f => ({ ...f, tipo: e.target.value }))}
                                className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 focus:ring-2 focus:ring-blue-400"
                            >
                                <option value="">Todos os Tipos</option>
                                {getOpcoesFiltro("vecarroceria").map(tipo => (
                                    <option key={tipo} value={tipo}>{tipo}</option>
                                ))}
                            </select>
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-neutral-700 mb-1">Cor</label>
                            <select
                                value={filtros.cor}
                                onChange={e => setFiltros(f => ({ ...f, cor: e.target.value }))}
                                className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 focus:ring-2 focus:ring-blue-400"
                            >
                                <option value="">Todas as Cores</option>
                                {getOpcoesFiltro("vecor").map(cor => (
                                    <option key={cor} value={cor}>{cor}</option>
                                ))}
                            </select>
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-neutral-700 mb-1">Número de Portas</label>
                            <select
                                value={filtros.portas}
                                onChange={e => setFiltros(f => ({ ...f, portas: e.target.value }))}
                                className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 focus:ring-2 focus:ring-blue-400"
                            >
                                <option value="">Qualquer</option>
                                {getOpcoesFiltro("veportas").map(portas => (
                                    <option key={portas} value={portas}>{portas}</option>
                                ))}
                            </select>
                        </div>

                        <div className="flex flex-col">
                            <label className="text-sm text-neutral-700 mb-1">KM Máxima</label>
                            <input
                                type="number"
                                placeholder="Qualquer KM"
                                value={filtros.kmMax}
                                onChange={e => setFiltros(f => ({ ...f, kmMax: e.target.value }))}
                                className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 placeholder:text-neutral-500 focus:ring-2 focus:ring-blue-400"
                            />
                        </div>

                        <div className="flex justify-center items-center col-span-1 md:col-span-2 lg:col-span-4 gap-6">
                            <div className="flex flex-col">
                                <label className="text-sm text-neutral-700 mb-1">Preço Mínimo</label>
                                <input
                                    type="number"
                                    placeholder={`R$ ${precoMinEstoque.toLocaleString("pt-BR")}`}
                                    value={filtros.precoMin}
                                    min={precoMinEstoque}
                                    max={precoMaxEstoque}
                                    onChange={e => setFiltros(f => ({ ...f, precoMin: e.target.value }))}
                                    className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 placeholder:text-neutral-500 focus:ring-2 focus:ring-blue-400"
                                />
                            </div>

                            <div className="flex flex-col">
                                <label className="text-sm text-neutral-700 mb-1">Preço Máximo</label>
                                <input
                                    type="number"
                                    placeholder={`R$ ${precoMaxEstoque.toLocaleString("pt-BR")}`}
                                    value={filtros.precoMax}
                                    min={precoMinEstoque}
                                    max={precoMaxEstoque}
                                    onChange={e => setFiltros(f => ({ ...f, precoMax: e.target.value }))}
                                    className="border rounded-md p-2 bg-white shadow-sm text-sm text-neutral-700 placeholder:text-neutral-500 focus:ring-2 focus:ring-blue-400"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
}
